import { render, staticRenderFns } from "./TagItemGroup.vue?vue&type=template&id=ea47b73e&scoped=true&"
import script from "./TagItemGroup.vue?vue&type=script&lang=js&"
export * from "./TagItemGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea47b73e",
  null
  
)

export default component.exports